import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'sb-radio-group',
  templateUrl: './sb-radio-group.component.html',
  styleUrls: ['./sb-radio-group.component.scss'],
  standalone: false,
})
export class SbRadioGroupComponent {
  @Output()
  selected: EventEmitter<string>;

  @Input()
  selectedVal?: string;

  @Input()
  selections: string[];
  @Input()
  selectionsHovers: { [key: string]: string };

  @Input()
  titles: { [key: string]: string };

  constructor() {
    this.titles = {};
    this.selections = [];
    this.selectionsHovers = {};
    this.selected = new EventEmitter<string>();
  }

  change(sel, $event) {
    if ($event.target.checked) {
      this.selectedVal = sel;
    } else {
      this.selectedVal = null;
    }

    const temp: string[] = this.selections;

    this.selections = [];

    this.selections = temp.slice(0);

    this.selected.emit(this.selectedVal);
  }
}
